import { isAnalysisMethod } from "../../typeGuards/isAnalysisMethod";
import { isGroupingFactor } from "../../typeGuards/isGroupingFactor";
import { isObjectRecord } from "../../typeGuards/isObjectRecord";
import { isOperation } from "../../typeGuards/isOperation";
import { ArsTableSidebarItemData } from "../interface";

/**
 * Type guard for ArsTable draggable sidebar payload items.
 *
 * @param obj - Unknown parsed payload item
 * @returns True when the value is a supported ArsTable sidebar item
 */
export const isArsTableSidebarItemData = (obj: unknown): obj is ArsTableSidebarItemData => {
  if (!isObjectRecord(obj) || !("kind" in obj) || !("dropItem" in obj)) {
    return false;
  }

  // Check sub object
  if (obj.kind === "groupingFactor") {
    return isGroupingFactor(obj.dropItem);
  } else if (obj.kind === "analysisMethod") {
    return isAnalysisMethod(obj.dropItem);
  } else if (obj.kind === "operation") {
    return isOperation(obj.dropItem);
  }

  // Not good
  return false;
};
